import React from "react";
import classes from "./loader.module.css";

function Loader() {
    return (
        <div
            className={`${classes.loader} align-items-center d-flex h-100 justify-content-center position-absolute w-100`}
        >
            <span className="spinner-border" role="status" aria-hidden="true"></span>
        </div>
    );
}

export default Loader;
